
import { connect } from "react-redux";
import { ForgotPassword } from "./forgot-password";

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = state => {
  return {
    client: state.client,
    config: state.app.config,
    wlf_id: state.app.wlf.id,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
